import ReactDOM from 'react-dom/client'
import App from './App'

const rootElement = document.getElementById('root')
const root = rootElement != null ? ReactDOM.createRoot(rootElement) : undefined

if (root != null) {
  root.render(<App />)
}
